import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeCrossedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 22.4 22.5",
	style: { enableBackground: "new 0 0 22.4 22.5" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.eye-crossed-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.eye-crossed-icon-st1{display:none;}\n	.eye-crossed-icon-st2{display:inline;}\n	.eye-crossed-icon-st3{fill:currentColor;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "eye-crossed-icon-st0",
			d: "M11.2,5.3c-6.4,0-9,6-9,6s2.6,6,9,6s9-6,9-6S17.6,5.3,11.2,5.3z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "eye-crossed-icon-st0",
			d: "M11.2,14.2c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3s-3,1.3-3,3C8.2,13,9.6,14.2,11.2,14.2z"
		})] }) }), /* @__PURE__ */ _jsx("path", {
			className: "eye-crossed-icon-st3",
			d: "M18.1,20.5L2.8,3.6c-0.4-0.4-0.4-1.2,0-1.7l0,0c0.4-0.4,1.1-0.4,1.5,0l15.2,16.9c0.4,0.4,0.4,1.2,0,1.7l0,0 C19.2,21,18.5,21,18.1,20.5z"
		})] }),
		/* @__PURE__ */ _jsx("g", {
			className: "eye-crossed-icon-st1",
			children: /* @__PURE__ */ _jsx("g", {
				className: "eye-crossed-icon-st2",
				children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "eye-crossed-icon-st0",
					d: "M11.2,5.2c-6.4,0-9,6-9,6s2.6,6,9,6s9-6,9-6S17.6,5.2,11.2,5.2z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "eye-crossed-icon-st0",
					d: "M11.2,14.2c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S9.5,14.2,11.2,14.2z"
				})] })
			})
		})
	]
});
export default SvgEyeCrossedIcon;
